import * as React from 'react';
import { ModalManager } from '@mui/material/Modal';
import { observer } from 'mobx-react';

import { DialogManager } from './DialogManager';
import { InputDialogBase, InputDialogConfig } from './InputDialogBase';

export const noClose: VoidFunction = (): void => { /* do nothing */ };

export interface InputDialogOptions {
    InputDialogConfig: InputDialogConfig;
    input?: true;
    onClose?: VoidFunction;
    onBackdropClick?: VoidFunction;
    // Note: it's important that all dialogs implement the force close callback
    onForceClose: VoidFunction;
}

interface InputDialogProps {
    dialogManager: DialogManager;
    manager?: ModalManager;
}

@observer
export class InputDialog extends React.Component<InputDialogProps> {
    constructor(props: InputDialogProps) {
        super(props);
        this.close = this.close.bind(this);
    }

    public override render(): React.ReactNode {
        if (this.props.dialogManager.dialog == null) {
            return null;
        }

        return (
            <InputDialogBase
                {...this.props.dialogManager.dialog.InputDialogConfig}
                noInput={this.props.dialogManager.dialog.input !== true}
                open={true}
                selectOnFocus={true}
                close={this.close}
                onBackdropClick={this.props.dialogManager.dialog.onBackdropClick}
                manager={this.props.manager}
            />
        );
    }

    protected close(): void {
        if (this.props.dialogManager.dialog?.onClose != null) {
            this.props.dialogManager.dialog.onClose();
        } else {
            this.props.dialogManager.closeDialog();
        }
    }
}